(function () {

  const initHeroColor = () => {

    const el = document.querySelector('.feature-1 .feature-article-hero__content');

    if (!el) {
      console.log('❌ hero要素が見つからない');
      return false;
    }

    const style = getComputedStyle(el);

    const start = style.getPropertyValue('--hero-color-start').trim();
    const end   = style.getPropertyValue('--hero-color-end').trim();

    if (!start || !end) {
      console.log('❌ CSS変数が取得できていない', { start, end });
      return false;
    }

    // カラー変換（安定版）
const toRGB = (color) => {

  // HEX (#fff / #ffffff)
  if (color.startsWith('#')) {
    let hex = color.replace('#', '');

    if (hex.length === 3) {
      hex = hex.split('').map(c => c + c).join('');
    }

    const num = parseInt(hex, 16);

    return [
      (num >> 16) & 255,
      (num >> 8) & 255,
      num & 255
    ];
  }

  // rgb / rgba
  if (color.startsWith('rgb')) {
    return color.match(/\d+/g).map(Number).slice(0, 3);
  }

  console.log('❌ 未対応カラー形式:', color);
  return null;
};

const startRGB = toRGB(start);
const endRGB   = toRGB(end);

if (!startRGB || !endRGB) {
  console.log('❌ RGB変換失敗', { start, end });
  return false;
}

const max = window.innerHeight * 0.2;

const update = () => {
  const progress = Math.min(window.scrollY / max, 1);

  const current = startRGB.map((s, i) =>
    Math.round(s + (endRGB[i] - s) * progress)
  );

  el.style.setProperty('--hero-current-color', `rgb(${current.join(',')})`);
};

    // ✅ 初期値セット（最重要）
    el.style.setProperty('--hero-current-color', start);

    // ✅ 初回実行
    update();

    // ✅ スクロールイベント
    window.addEventListener('scroll', update, { passive: true });

    console.log('✅ hero color 初期化完了');

    return true;
  };

  // -------------------------------
  // 実行タイミング制御（重要）
  // -------------------------------

  const run = () => {
    // すぐ試す
    if (initHeroColor()) return;

    // 少し待って再試行（Prestige対策）
    setTimeout(() => {
      if (initHeroColor()) return;
    }, 300);

    // さらに保険（遅延レンダリング対策）
    setTimeout(() => {
      initHeroColor();
    }, 800);
  };

  // DOM + 画像 + セクション全部読み込み後
  window.addEventListener('load', run);

})();